import { useCheckValidity } from '@library/hooks'
import { convertToNumber } from '@library/utils'
import type { FC } from 'react'

import type { NumericInputProps } from '../../../../components'
import { NumericInput } from '../../../../components'
import { NumberInputValidator } from './Validators'

type SingleInputProps = NumericInputProps & {
  units?: string
  errorText?: string
  min?: number
  max?: number
}

export const SingleInput: FC<SingleInputProps> = ({
  className,
  min,
  max,
  value,
  mode,
  label,
  step,
  onChange,
  onSetDefault,
  units,
  errorText,
  status,
  placeholder,
  withClearButton,
  disabled = false,
  ref,
  ...rest
}) => {
  const validator = new NumberInputValidator(min, max)
  const [validation, isValid, setChecked] = useCheckValidity(validator.validate, {
    value: convertToNumber(value ?? null),
  })

  const handleChange: typeof onChange = (value, params) => {
    setChecked({ value: convertToNumber(value) })

    onChange?.(value, params)
  }

  return (
    <NumericInput
      autoFocus={true}
      incrementButtons={true}
      labelPosition="left"
      size="xs"
      status={errorText !== undefined || !isValid ? 'alert' : status}
      caption={validation.value ?? errorText}
      className={className}
      value={value}
      mode={mode}
      placeholder={placeholder}
      label={label}
      leftSide={units}
      step={step}
      withClearButton={withClearButton}
      disabled={disabled}
      onChange={handleChange}
      onSetDefault={onSetDefault}
      {...rest}
    />
  )
}
